import * as React from 'react';

/**
 * A preview URL for a locally selected file. The URL is revoked when the file changes or the
 * component unmounts, so selected files are not pinned in memory.
 */
export function useObjectUrl(file: Blob | null | undefined) {
  const [preview, setPreview] = React.useState<{ file: Blob; url: string } | null>(null);

  React.useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    // The object URL is an external resource owned by this effect: created here, revoked in its
    // cleanup. Creating it during render would leak URLs from discarded (or double) renders.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPreview({ file, url });
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  // Never hand out the previous file's (already revoked) URL while the new one is being created.
  return file && preview?.file === file ? preview.url : null;
}
